import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-mdm-ldap>
  <paedml-modal prefix={opts.prefix} 
      heading={opts.heading} opname={opts.opname} edit={opts.edit} 
      selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
      submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="row" if={!parent.data.initialized}>
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-danger">
              <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                  <strong class="text-danger pl-1 pt-2">Der MDM-Server ist noch nicht gestartet oder vollständig konfiguriert. Die LDAP-Verbindung kann nicht zurückgesetzt werden.</strong>
              </span>
              </div>
          </div>
      </div>

      <div class="row" if={parent.data.initialized}>
        <div class="col-md-12">
          <p>Die LDAP-Verbindung wird auf den Standardwert zurückgesetzt.</p>
        </div>
      </div>

    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      import API from '../../api'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true

      this.data = {
        initialized: false
      }

      this.on('dataRequested', (e) => {
        let status = e.data()[0][8]
        this.data.initialized = status === 5
      })

      this.submitHandler = formData => {
      
        if(!this.data.initialized){
          return Promise.resolve('Operation abgebrochen')
        }

        return API.mdm.ldap().then(rsp => {
          const [data, status] = rsp
          if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

          if(status.success) {
            
            this.parent.trigger('reloadTable')

            return 'Update der MDM Umgebung wurde erfolgreich gestartet.'
          }
        })
    }
    </script>
</paedml-modal-mdm-ldap>